/* LE-04: one line icon per stage in "The Art of Chocolate Making". Static, hand-drawn SVG; the stage name picks the icon. */
(() => {
  const root = document.querySelector('[data-stage-icons]');
  if (!root) return;
  const S = d => `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
  const ICONS = {
    roasting: S('<path d="M16 4c1 4 6 6 6 12a6 6 0 0 1-12 0c0-3 2-4 3-7 1 1 2 2 2 3 1-2 1-5 1-8z"/><path d="M8 28h16"/>'),
    winnowing: S('<path d="M4 11h15a3 3 0 1 0-3-3"/><path d="M4 17h21a3 3 0 1 1-3 3"/><path d="M4 23h11"/>'),
    grinding: S('<circle cx="16" cy="16" r="9"/><circle cx="16" cy="16" r="3"/><path d="M16 7v6M16 19v6M7 16h6M19 16h6"/>'),
    blending: S('<path d="M10 6c0 4-4 6-4 10a6 6 0 0 0 12 0c0-4-4-6-4-10"/><path d="M20 12c3 2 6 4 6 8a5 5 0 0 1-8 4"/>'),
    conching: S('<path d="M3 18c3-5 5-5 8 0s5 5 8 0 5-5 8 0"/><path d="M3 24c3-5 5-5 8 0s5 5 8 0 5-5 8 0"/><path d="M3 12c3-5 5-5 8 0s5 5 8 0 5-5 8 0"/>'),
    tempering: S('<path d="M13 5a3 3 0 0 1 6 0v13a6 6 0 1 1-6 0z"/><path d="M16 12v9"/>'),
    storage: S('<path d="M4 11l12-6 12 6v14H4z"/><path d="M4 11l12 6 12-6M16 17v8"/>')
  };
  /* i18n: a heading also matches its localized stage name, from window.FR_STRINGS.stage_<key>
     (locale keys store.js.stage_roasting … store.js.stage_storage). English matching is unchanged. */
  const L = window.FR_STRINGS || {};
  const pick = t => {
    t = t.toLowerCase();
    return Object.keys(ICONS).find(k => t.startsWith(k) || (L['stage_' + k] && t.startsWith(String(L['stage_' + k]).toLowerCase())));
  };
  root.querySelectorAll('h2').forEach(h => {
    const k = pick(h.textContent.trim());
    if (!k) return;
    h.classList.add('stage-title');
    const span = document.createElement('span');
    span.className = 'stage-icon';
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML = ICONS[k];
    h.prepend(span);
  });
})();
